import React, { useContext, useCallback, useState, useEffect } from 'react';
import find from 'lodash/find';
import get from 'lodash/get';
import set from 'lodash/set';

import FormContext from 'src/presentation/contexts/FormContext';
import { InputField } from 'src/presentation/components/agent_desktop_components';

export const NanoSecondsInputField = ({ 'data-aid': dataAid, attr, label, description, ...otherProps }) => {
  const { errors, workingState, updateState, resetError, onBlur } = useContext(FormContext);

  const error = find(errors, error => error.attr === attr);
  const valueInSeconds = Math.round(get(workingState, attr, 0) / 1000000000);
  const [input, setInput] = useState(valueInSeconds.toString());

  const onChange = useCallback(
    (val = '') => {
      let value;

      if (!val) {
        value = 0;
      } else {
        if (!isPositiveInteger(val)) {
          return false;
        }
        value = parseInt(val);
      }
      setInput(val);
      resetError({ attr, errors });
      const inNanoSeconds = Number(value || 0) * 1000000000;
      updateState(set({}, attr, inNanoSeconds));
    },
    [attr, errors, resetError, updateState]
  );

  useEffect(() => {
    if (valueInSeconds === 0) {
      onChange(String(5));
    }
    // eslint-disable-next-line
  }, []);

  return (
    <InputField
      data-aid={dataAid}
      description={description}
      label={label}
      onChange={onChange}
      value={input}
      onBlur={onBlur}
      error={get(error, 'detail')}
      {...otherProps}
    />
  );
};

function isPositiveInteger(strNumber: string): boolean {
  const n = Math.floor(Number(strNumber));
  return n !== Infinity && String(n) === strNumber && n >= 0;
}
